export default "__VITE_ASSET__b0c46fb3__"